//Triggers when cart gets updated
document.addEventListener("cart:updated", updatecart);
function updatecart(event) {
  if(event.detail.cart.status == 422){ //Error while updating the cart
      var element = document.getElementsByClassName('is-loading');
      const className = "is-loading";
      removeClass(element,className);
    }else{
        event.detail.cart.items.forEach((item) => {
          var key = item.key;
          var qtyElementToUpdate = document.querySelectorAll(
            '[data-variant-id= "' + item.id + '"]'
          );
          
         [].forEach.call(qtyElementToUpdate, function (el) {
            el.value = item.quantity;
          });
      
          var qtyWrapperToUpdate = document.querySelectorAll(
          '[data-product-id-quantity-plp= "' + item.id + '"]'
          );
          
          [].forEach.call(qtyWrapperToUpdate, function (el) {
              removeQtyLoader(el);
          });
          /* Cart threshold limit */
          manageCartThresholdMessage(event.detail.cart.total_price);
          /* Cart threshold limit */
      });
          window.addonOrderDateChanged?.();
  }
}

// Function to show quantity selector and hide add to cart
function showQuantityHideAddToCart(product_id) {
  var childquantelement = document.querySelectorAll(
    '[data-product-id-quantity= "' + product_id + '"]'
  );
  [].forEach.call(childquantelement, function (el) {
    el.classList.remove("quantity-selector-disable");
  });

  var ParentAddToCart = document.querySelectorAll(
    '[data-product-id-add= "' + product_id + '"]'
  );
  [].forEach.call(ParentAddToCart, function (elem) {
    elem.classList.add("addtocart-disable");
  });

  var qtyWrapperToUpdate = document.querySelectorAll(
  '[data-product-id-quantity-plp= "' + product_id + '"]'
  );
    
    [].forEach.call(qtyWrapperToUpdate, function (el) {
        removeQtyLoader(el);
    });
}

  //Function to remove the loader from Qty Input (+/-)
  function removeQtyLoader(element){
    const delay = 1000;
        setTimeout(() => {
          element.classList.remove('is-loading');
    },delay);
  }

  // function to remove class 'is-loading'
  function removeClass(elements,className) {
    if(elements instanceof HTMLCollection){
      elements=Array.from(elements);
    }
    elements.forEach(element => {
      if(element.classList){
        element.classList.remove(className);
      }
    });
  }

//Triggers when product is added to cart
document.addEventListener("ajaxProduct:added", function (evt) {
  fetch("/cart.js")
    .then((response) => {
      if (!response.ok) {
        throw new Error("Failed to fetch");
      }
      return response.json();
    })
    .then((cartData) => {
      var newItem = evt.detail.product; // PDP cart item check
      const exist = 'items' in evt.detail.product; // PLP Grid items check
      if(exist){
        newItem = evt.detail.product.items[0];
      }
      const cartItems = cartData.items; //Cart Items
      const qtyInput = document.querySelectorAll(
        '[data-id= "' + newItem.id + '"]'
      );
      [].forEach.call(qtyInput, function (el) {
        el.value = newItem.quantity;
      });
      showQuantityHideAddToCart(newItem.id);
      /* Cart threshold limit */
      manageCartThresholdMessage(cartData.total_price);
      /* Cart threshold limit */
      window.addonOrderDateChanged?.();

      // This condition is being added when cart was empty to refresh the page to fix issue
      if(cartItems.length == 1 && window.location.pathname == '/cart'){
        window.location.reload();
      }
      // ../ This condition is being added when cart was empty to refresh the page

    })
    .catch((error) => {
      console.error("Error", error);
    });
    

    

});
/// Grab the qty input
const customQtyInput = document.querySelector('.custom_qty_input')
/// Update qty input when enter
customQtyInput.addEventListener('keydown',function(e) {
        if (e.keyIdentifier=='U+000A' || e.keyIdentifier=='Enter' || e.keyCode==13 || e.code === 'Enter' || e.key === 'Enter') {
          if (e.target.nodeName=='INPUT' && e.target.type=='text') {
            let quantityLabel=document.querySelector(".custom-quantity-selector .qty-wrapper label");
            this.blur();
            e.preventDefault();
          }
        }
    })

 /* Cart threshold limit */
function manageCartThresholdMessage(cartTotalValue) {
  const cartSubtotal = cartTotalValue / 100.0;
  const thresholdPara = document.querySelector(".cart_threshold_message");
  if (cartSubtotal < 100) {
    if (thresholdPara) {
      if (thresholdPara.classList.contains("hide_cart_threshold_message")) {
        thresholdPara.classList.remove("hide_cart_threshold_message");
        thresholdPara.classList.add("show_cart_threshold_message");
      }
      disableCheckoutButton(true);
    }
  } else {
    if (thresholdPara) {
      if (thresholdPara.classList.contains("show_cart_threshold_message")) {
        thresholdPara.classList.remove("show_cart_threshold_message");
        thresholdPara.classList.add("hide_cart_threshold_message");
      }
      disableCheckoutButton(false);
    }
  }
}

function disableCheckoutButton(hide) {
  const checkoutButtons = document.querySelectorAll(
    ".cart__item-row.cart__checkout-wrapper .btn.cart__checkout"
  );
  checkoutButtons.forEach((button) => {
    button.disabled = hide;
  });
}   
/* Cart threshold limit */